import React, { useEffect, useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import axios from "axios";
import { NODE_API_URL, BASE_URL } from "../../../env_config";
import Cookies from "js-cookie";
import CcmodeThemeSetting from "./CcmodeThemeSetting";
import CcmodeTaxSetting from "./CcmodeTaxSetting";
import CcmodeInviteUser from "./CcmodeInviteUser/CcmodeInviteUser";
import CcmodeParameterPermissions from "./CcmodeParameterPermissions";
import { makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import CCmodeSettingContext from "../../../context/ccmodeSettingContext";

const useStyles = makeStyles((theme) => ({
    cardBody: {
        [theme.breakpoints.up("xs")]: {
            padding: `0px !important`,
        },
        [theme.breakpoints.up("sm")]: {
            padding: `${0.25 * 10}rem !important`,
        },
    },
}));

export const CcmodeSettingNew = (props) => {
    const classes = useStyles();
    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.down("md"));

    const [key, setKey] = useState("ccmodetheme");
    const [isFormChanged, setIsFormChanged] = useState(false);
    const [showFormChangePopUp, setShowFormChangePopUp] = useState(false);
    const [nextKey, setNextKey] = useState(null);

    const [ccmodesetting, setCCModeSetting] = useState(null);

    useEffect(() => {
        const source = axios.CancelToken.source();

        if (props?.userinfo?.id) {
            axios({
                method: "get",
                url: `${NODE_API_URL}/INTL/fetch-ccmode-setting-data`,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
                },
                cancelToken: source.token,
            })
                .then((res) => {
                    if (
                        res &&
                        res.data &&
                        res.data.data &&
                        res.data.data.length
                    ) {
                        setCCModeSetting(res.data.data[0]);
                    }
                })
                .catch((error) => {
                    if (error?.response?.data?.message === "UnAuthorized!") {
                        var cookies = document.cookie.split(";");
                        for (var i = 0; i < cookies.length; i++) {
                            if (cookies[i] && !cookies[i].includes("view")) {
                                var equals = cookies[i].indexOf("=");
                                var name =
                                    equals > -1
                                        ? cookies[i].substr(0, equals)
                                        : cookies[i];
                                document.cookie =
                                    name +
                                    "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                            }
                        }

                        window.location.replace(`${BASE_URL}/logout`);
                    }
                });
        }

        return () => {
            source.cancel("Component unmounted: cancel pending request");
        };
    }, [props.userinfo.id]);

    function handleTabChange(tabName){
        if(tabName === key) return;
        
        if(isFormChanged){
            setShowFormChangePopUp(true)
            setNextKey(tabName);
            return
        }

        setNextKey(null);
        setKey(tabName)
    } 

    return ccmodesetting ? (
        <CCmodeSettingContext.Provider
            value={{ activeKey: key, setActiveKey: setKey, isFormChanged, setIsFormChanged, showFormChangePopUp, setShowFormChangePopUp, nextKey, setNextKey }}
        >
            <div className="container-fluid feed-theme">
                <Tab.Container
                    id="settingTab"
                    activeKey={key}
                    onSelect={(k) => handleTabChange(k)}
                >
                    <div className="row">
                        <div
                            className={`${
                                isMd ? "col-12" : "col-3"
                            } card custom-card border-0 rounded-0`}
                        >
                            <div>
                                <Nav
                                    variant="pills"
                                    className="flex-column custom_nav"
                                >
                                    <Nav.Item>
                                        <Nav.Link
                                            className="flex-wrap"
                                            eventKey="ccmodetheme"
                                        >
                                            <span className="font-size-h5 px-0 col-12">
                                                CCMODE Theme
                                            </span>
                                            <span className="text-muted small px-0 col-12">
                                                Client Centric mode theme
                                                setting
                                            </span>
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link
                                            className="flex-wrap"
                                            eventKey="ccmodetax"
                                        >
                                            <span className="font-size-h5 px-0 col-12">
                                                CCMODE Currency & Tax
                                            </span>
                                            <span className="text-muted small px-0 col-12">
                                                Client Centric mode Currency &
                                                Tax setting
                                            </span>
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link
                                            className="flex-wrap"
                                            eventKey="ccmodeparameterpermissions"
                                        >
                                            <span className="font-size-h5 px-0 col-12">
                                                CCMODE Parameter Permissions
                                            </span>
                                            <span className="text-muted small px-0 col-12">
                                                Client Centric mode parameter
                                                Permissions
                                            </span>
                                        </Nav.Link>
                                    </Nav.Item>
                                    <Nav.Item>
                                        <Nav.Link
                                            className="flex-wrap"
                                            eventKey="ccmodeuserinvite"
                                        >
                                            <span className="font-size-h5 px-0 col-12">
                                                CCMODE Manage User
                                            </span>
                                            <span className="text-muted small px-0 col-12">
                                                Client Centric mode manage user
                                            </span>
                                        </Nav.Link>
                                    </Nav.Item>
                                </Nav>
                            </div>
                        </div>
                        <div
                            className={`${
                                isMd ? "col-12" : "col-9"
                            } card bg-white custom-card custom-scrollbar`}
                            style={{ maxHeight: "85vh" }}
                        >
                            <div
                                className={`card-body ${classes.cardBody}`}
                                id="themesetting"
                            >
                                <Tab.Content>
                                    <Tab.Pane eventKey="ccmodetheme">
                                        <CcmodeThemeSetting
                                            userinfo={props.userinfo}
                                            language={props.language}
                                            ccmodesetting={ccmodesetting}
                                        />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="ccmodetax">
                                        <CcmodeTaxSetting
                                            userinfo={props.userinfo}
                                            language={props.language}
                                            ccmodesetting={ccmodesetting}
                                        />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="ccmodeparameterpermissions">
                                        <CcmodeParameterPermissions
                                            userinfo={props.userinfo}
                                            language={props.language}
                                            ccmodesetting={ccmodesetting}
                                        />
                                    </Tab.Pane>
                                    <Tab.Pane eventKey="ccmodeuserinvite">
                                        <CcmodeInviteUser
                                            language={props.language}
                                            ccmodesetting={ccmodesetting}
                                        />
                                    </Tab.Pane>
                                </Tab.Content>
                            </div>
                        </div>
                    </div>
                </Tab.Container>
            </div>
        </CCmodeSettingContext.Provider>
    ) : (
        ""
    );
};
